module.exports = __webpack_public_path__ + "static/media/015-Aktivierung_ID_11.e9074ebf.mp3";